import { useEffect } from 'react';

import getProductSlugFromUrl from '@lib/getProductSlugFromUrl';

export const useTrack = (eventName, properties) => {
  useEffect(() => {
    if (window.heap) {
      window.heap.track(eventName, properties);
    }
  }, []);
};

export const track = (eventName, properties) => {
  if (window.heap) {
    window.heap.track(eventName, properties);
  }
};

export const trackAdrollView = () => {
  if (!window.adroll) return;

  if (window.location.pathname === '/') {
    window.adroll.track('homeView');
  } else {
    const productSlug = getProductSlugFromUrl();
    window.adroll.track('pageView', { product_id: productSlug });
  }
};
